// Module
var code = `<div class="hoa-dialog__container">
    <div class="hoa-dialog__header">
        <h1 tid="paymentScheduleOverlapHeader">Payment Schedule Overlap</h1>
    </div>
    <div class="hoa-dialog__main hoa-dialog__main--marginNone">
        <div class="hoa-dialog__HOA-container-scrollableContent__scheduleOverlap" style="height: 200px;">
            <strong tid="paymentScheduleOverlapBody1">Payment Schedules</strong>
            <p tid="paymentScheduleOverlapBody2">You have a payment(s) scheduled on the selected date. </p>
            <div *ngFor="let schedule of data.schedules; index as \$index">
                <strong [attr.tid]="'paymentScheduleOverlapNickname' + \$index">{{schedule.nickname}}</strong> <br>
                Start Date: {{schedule.startDate.format("MMM dd, yyyy")}} <br>
                End Date: {{schedule.endDate.format("MMM dd, yyyy")}} <br>
                <span *ngIf="schedule.futurePayment && schedule.futurePayment.total ">
                            Amount: {{'\$' + schedule.futurePayment.total.toFixed(2)}}
                        </span>
                <span *ngIf="!schedule.futurePayment || !schedule.futurePayment.total">
                            Amount: \$0.00
                        </span>
                <br><br>
            </div>
            <p tid="paymentScheduleOverlapBody3">Payment dates can be updated in the Scheduled Payments
                Section.</p>
            <p tid="paymentScheduleOverlapBody4">Do you want to continue with this payment schedule?</p>
        </div>
    </div>
    <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
        <button class="Button Button--link Button--minWidth130" tid="paymentScheduleOverlapNo"
                (click)="closeThisDialog(false)">No
        </button>
        <button class="Button Button--blue Button--minWidth130" tid="paymentScheduleOverlapYes"
                (click)="closeThisDialog(true)">Yes
        </button>
    </div>
</div>`;
// Exports
module.exports = code;